import { Component, OnInit, OnDestroy } from '@angular/core';
import { TimezoneService, TimezoneConfig } from '../../services/timezone.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'sa-timezone-toggle',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule],
  templateUrl: './timezone-toggle.component.html',
  styleUrls: ['./timezone-toggle.component.scss']
})
export class TimezoneToggleComponent implements OnInit, OnDestroy {
  config: TimezoneConfig | null = null;
  showToggle: boolean = false;
  private subscription: Subscription | null = null;

  constructor(private timezoneService: TimezoneService) {}

  ngOnInit(): void {
    this.showToggle = this.timezoneService.isDifferentFromPacific();

    this.subscription = this.timezoneService.getTimezoneConfig().subscribe(config => {
      this.config = config;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onToggle(): void {
    this.timezoneService.toggleTimezone();
  }

  get checkboxLabel(): string {
    if (!this.config) {
      return '';
    }
    return `Show times in ${this.config.userTimezoneAbbr}`;
  }
}
